export const getValueByKey = (object, path: string) => {
    if (!path || path.length == 0) {return undefined;}
    const props = path.split(".");
    for (let i = 0; i < props.length; i++) {
        const p = props[i];
        if (object && object.hasOwnProperty(p)) {
            object = object[p];
        } else {
            return undefined;
        }
    }
    return object;
};

export const setValueByKey = (object, path: string, value) => {
    const obj = JSON.parse(JSON.stringify(object))
    const  list = path.split(".");
    let th = "";
    for (let i = 0; i < list.length; i++) {
        th += "['" + list[i] + "']";
        eval(`if(!obj${th}) {obj${th} = list[i+1] && Number(list[i+1])+1 ? [] : {}}`);
    }
    eval(`obj${th}= value`);
    return obj;
}